import { TwitterFollowButton, TwitterHashtagButton, TwitterMentionButton, TwitterTweetEmbed } from 'react-twitter-embed';
import TextLoop from "react-text-loop";
import { Emojione } from "react-emoji-render";
import Warning from "../../../../src/components/Presentations/Warning";
import Success from "../../../../src/components/Presentations/Success";
import CodeBlock from "../../../../src/components/Presentations/CodeBlock";
import AnimatedBackground from "../../../../src/components/Presentations/AnimatedBackground";
import Confetti from "../../../../src/components/Presentations/Confetti";
import QandA from "../../../../src/components/Presentations/QandA";
import HTMLEditor from "../../../../src/components/HTMLEditor/HTMLEditorSimple";
import Poll from "../../../../src/components/Presentations/Poll";
import CoderSchoolLogo from "../../../../MDX/Decks/FTW-PRECOURSE-1/img/cs-logo.png";
import CharlesPic from "../../../../MDX/Decks/FTW-PRECOURSE-1/img/charles.png";
import VinhPic from "../../../../MDX/Decks/FTW-PRECOURSE-1/img/vinh.jpg";
import EmptyRoom from "../../../../MDX/Decks/FTW-PRECOURSE-1/img/emptyroom.jpg";
import Office from "../../../../MDX/Decks/FTW-PRECOURSE-1/img/office.jpg";
import Bedroom from "../../../../MDX/Decks/FTW-PRECOURSE-1/img/bedroom.jpg";
import * as React from 'react';
export default {
  TwitterFollowButton,
  TwitterHashtagButton,
  TwitterMentionButton,
  TwitterTweetEmbed,
  TextLoop,
  Emojione,
  Warning,
  Success,
  CodeBlock,
  AnimatedBackground,
  Confetti,
  QandA,
  HTMLEditor,
  Poll,
  CoderSchoolLogo,
  CharlesPic,
  VinhPic,
  EmptyRoom,
  Office,
  Bedroom,
  React
};